module.exports = __webpack_public_path__ + "static/media/Ellipse4.9828640c.png";